import { regionExteriorPayoutErrors, requiredPercentageErrors } from 'utils';
import { RegionFormValues } from '../containers/useRegionContainer';

type ValidationErrors = Record<string, string[] | undefined>;

export const validateRegion = async (
  values: RegionFormValues,
): Promise<ValidationErrors> => {
  const errors: ValidationErrors = {};
  if (!values.name) {
    errors.name = ['The Name is required'];
  }
  if (values.repairsRate) {
    if (values.repairsRate < 1) {
      errors.repairsRate = ['The Repairs Rate must be at least 1'];
    }
    if (values.repairsRate > 99.99) {
      errors.repairsRate = ['The Repairs Rate must be 99.99 or less'];
    }
  } else {
    errors.repairsRate = ['The Repairs Rate is required'];
  }

  if (values.garageCostFixed && values.garageCostFixed < 0) {
    errors.garageCostFixed = ['The Garage (Fixed cost) must be at least 0'];
  }

  if (!values.garageCostFixed && values.garageCostFixed !== 0) {
    errors.garageCostFixed = ['The Garage (Fixed cost) is required'];
  }

  if (values.highCeilingPerBoard && values.highCeilingPerBoard < 0) {
    errors.highCeilingPerBoard = [
      'The High Ceiling (Per Board) must be at least 0',
    ];
  }

  if (!values.highCeilingPerBoard && values.highCeilingPerBoard !== 0) {
    errors.highCeilingPerBoard = ['The High Ceiling (Per Board) is required'];
  }

  if (values.screwInspectionPerBoard && values.screwInspectionPerBoard < 0) {
    errors.screwInspectionPerBoard = [
      'The Screw Inspection (Per Board) must be at least 0',
    ];
  }

  if (!values.screwInspectionPerBoard && values.screwInspectionPerBoard !== 0) {
    errors.screwInspectionPerBoard = [
      'The Screw Inspection (Per Board) is required',
    ];
  }

  const pieceworkErrors = requiredPercentageErrors(
    values.pieceworkPercentage,
    'Piecework Percentage',
  );
  if (pieceworkErrors) {
    errors.pieceworkPercentage = pieceworkErrors;
  }

  const specialJobsErrors = requiredPercentageErrors(
    values.specialJobsPercentage,
    'Special Jobs Percentage',
  );
  if (specialJobsErrors) {
    errors.specialJobsPercentage = specialJobsErrors;
  }

  // Driwall Fields Section

  if (values.phaseStructureType === 'Drywall') {
    if (values.dwHangingCostPerBoard && values.dwHangingCostPerBoard < 0) {
      errors.dwHangingCostPerBoard = [
        'The Hanging (Per board) must be at least 0',
      ];
    }

    if (!values.dwHangingCostPerBoard && values.dwHangingCostPerBoard !== 0) {
      errors.dwHangingCostPerBoard = ['The Hanging (Per board) is required'];
    }

    if (values.dwFinishingCostPerBoard && values.dwFinishingCostPerBoard < 0) {
      errors.dwFinishingCostPerBoard = [
        'The Finishing (Per board) must be at least 0',
      ];
    }

    if (
      !values.dwFinishingCostPerBoard &&
      values.dwFinishingCostPerBoard !== 0
    ) {
      errors.dwFinishingCostPerBoard = [
        'The Finishing (Per board) is required',
      ];
    }

    if (values.dwSprayingCostPerBoard && values.dwSprayingCostPerBoard < 0) {
      errors.dwSprayingCostPerBoard = [
        'The Spraying (Per board) must be at least 0',
      ];
    }

    if (!values.dwSprayingCostPerBoard && values.dwSprayingCostPerBoard !== 0) {
      errors.dwSprayingCostPerBoard = ['The Spraying (Per board) is required'];
    }
  }

  // Drywall Paint Section

  if (values.phaseStructureType === 'DrywallAndPaint') {
    if (values.dwpHangingCostPerBoard && values.dwpHangingCostPerBoard < 0) {
      errors.dwpHangingCostPerBoard = [
        'The Hang (Per board) must be at least 0',
      ];
    }

    if (!values.dwpHangingCostPerBoard && values.dwpHangingCostPerBoard !== 0) {
      errors.dwpHangingCostPerBoard = ['The Hang (Per board) is required'];
    }

    if (values.dwpFinishCostPerBoard && values.dwpFinishCostPerBoard < 0) {
      errors.dwpFinishCostPerBoard = [
        'The Finish (Per Board) must be at least 0',
      ];
    }

    if (!values.dwpFinishCostPerBoard && values.dwpFinishCostPerBoard !== 0) {
      errors.dwpFinishCostPerBoard = ['The Finish (Per Board) is required'];
    }

    if (values.dwpPrimeCostPerSqft && values.dwpPrimeCostPerSqft < 0) {
      errors.dwpPrimeCostPerSqft = ['The Prime (Per Sq Ft) must be at least 0'];
    }

    if (!values.dwpPrimeCostPerSqft && values.dwpPrimeCostPerSqft !== 0) {
      errors.dwpPrimeCostPerSqft = ['The Prime (Per Sq Ft) is required'];
    }

    if (values.dwpBump1CostPerBoard && values.dwpBump1CostPerBoard < 0) {
      errors.dwpBump1CostPerBoard = [
        'The Drywall Touch Up 1 (Per board) must be at least 0',
      ];
    }

    if (!values.dwpBump1CostPerBoard && values.dwpBump1CostPerBoard !== 0) {
      errors.dwpBump1CostPerBoard = [
        'The Drywall Touch Up 1 (Per board) is required',
      ];
    }

    if (values.dwpTrim1CostPerSqft && values.dwpTrim1CostPerSqft < 0) {
      errors.dwpTrim1CostPerSqft = [
        'The Trim 1 (Per Sq Ft) must be at least 0',
      ];
    }

    if (!values.dwpTrim1CostPerSqft && values.dwpTrim1CostPerSqft !== 0) {
      errors.dwpTrim1CostPerSqft = ['The Trim 1 (Per Sq Ft) is required'];
    }
    if (
      values.dwpInteriorPaintCostPerSqft &&
      values.dwpInteriorPaintCostPerSqft < 0
    ) {
      errors.dwpInteriorPaintCostPerSqft = [
        'The Interior Paint (Per Sq Ft) must be at least 0',
      ];
    }

    if (
      !values.dwpInteriorPaintCostPerSqft &&
      values.dwpInteriorPaintCostPerSqft !== 0
    ) {
      errors.dwpInteriorPaintCostPerSqft = [
        'The Interior Paint (Per Sq Ft) is required',
      ];
    }

    if (values.dwpBump2CostPerBoard && values.dwpBump2CostPerBoard < 0) {
      errors.dwpBump2CostPerBoard = [
        'The Drywall Touch Up 2 (Per board) must be at least 0',
      ];
    }

    if (!values.dwpBump2CostPerBoard && values.dwpBump2CostPerBoard !== 0) {
      errors.dwpBump2CostPerBoard = [
        'The Drywall Touch Up 2 (Per board) is required',
      ];
    }

    if (values.dwpTrim2CostPerSqft && values.dwpTrim2CostPerSqft < 0) {
      errors.dwpTrim2CostPerSqft = [
        'The Trim 2 (Per Sq Ft) must be at least 0',
      ];
    }

    if (!values.dwpTrim2CostPerSqft && values.dwpTrim2CostPerSqft !== 0) {
      errors.dwpTrim2CostPerSqft = ['The Trim 2 (Per Sq Ft) is required'];
    }

    if (
      values.dwpFinalPaintCostPerSqft &&
      values.dwpFinalPaintCostPerSqft < 0
    ) {
      errors.dwpFinalPaintCostPerSqft = [
        'The Final Paint (Per Sq Ft) must be at least 0',
      ];
    }

    if (
      !values.dwpFinalPaintCostPerSqft &&
      values.dwpFinalPaintCostPerSqft !== 0
    ) {
      errors.dwpFinalPaintCostPerSqft = [
        'The Final Paint (Per Sq Ft) is required',
      ];
    }

    if (values.dwpBump3CostPerBoard && values.dwpBump3CostPerBoard < 0) {
      errors.dwpBump3CostPerBoard = [
        'The Drywall Touch Up 3 (Per board) must be at least 0',
      ];
    }

    if (!values.dwpBump3CostPerBoard && values.dwpBump3CostPerBoard !== 0) {
      errors.dwpBump3CostPerBoard = [
        'The Drywall Touch Up 3 (Per board) is required',
      ];
    }

    if (
      values.dwpCMBluetapeCostPerSqft &&
      values.dwpCMBluetapeCostPerSqft < 0
    ) {
      errors.dwpCMBluetapeCostPerSqft = [
        'The CM Bluetape (Per Sq Ft) must be at least 0',
      ];
    }

    if (
      !values.dwpCMBluetapeCostPerSqft &&
      values.dwpCMBluetapeCostPerSqft !== 0
    ) {
      errors.dwpCMBluetapeCostPerSqft = [
        'The CM Bluetape (Per Sq Ft) is required',
      ];
    }

    if (
      values.dwpFinalBluetapeCostPerSqft &&
      values.dwpFinalBluetapeCostPerSqft < 0
    ) {
      errors.dwpFinalBluetapeCostPerSqft = [
        'The Final Bluetape (Per Sq Ft) must be at least 0',
      ];
    }

    if (
      !values.dwpFinalBluetapeCostPerSqft &&
      values.dwpFinalBluetapeCostPerSqft !== 0
    ) {
      errors.dwpFinalBluetapeCostPerSqft = [
        'The Final Bluetape (Per Sq Ft) is required',
      ];
    }

    const interiorOptionsErrors = requiredPercentageErrors(
      values.interiorOptionsPercentage,
      'Paint Interior Options',
    );
    if (interiorOptionsErrors) {
      errors.interiorOptionsPercentage = interiorOptionsErrors;
    }

    const exteriorOptionsErrors = requiredPercentageErrors(
      values.exteriorOptionsPercentage,
      'Paint Exterior Options',
    );
    if (exteriorOptionsErrors) {
      errors.exteriorOptionsPercentage = exteriorOptionsErrors;
    }

    const trimOptionErrors = requiredPercentageErrors(
      values.trimOptionPercentage,
      'Trim Option',
    );
    if (trimOptionErrors) {
      errors.trimOptionPercentage = trimOptionErrors;
    }

    Object.assign(errors, regionExteriorPayoutErrors(values));
  }

  return errors;
};
